var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import OnlineChatLink from '../../../../ui/atoms/OnlineChatLink';
import i18n, { t } from '../../../../strings/i18n/i18n';
import { Trans } from 'react-i18next';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import LaunchPointName from '../../../../const/launchPointName';
import { closeModalHelper } from '../../../../ui/patterns/SlideinModal/helpers/closeHandlers';
import { DisputeFeature } from '../../../../typings';
import { Body } from 'syf-component-library/ui/typography';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { ContactFraudImageContainer, Content, Header } from '../ContactFraud/subcomponents';
var Description = styled(Body)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n  text-align: center;\n"], ["\n  margin-top: ", "px;\n  text-align: center;\n"])), spacing.small);
var CantIdentifyDup = function () {
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var dispatch = useDispatch();
    var assetsURL = useSelector(function (state) { return state; }, shallowEqual).mfeConfig.assetsURL;
    var accountId = useSelector(function (state) { return state.appConfig; }).accountId;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    var handleLaunchChat = function () {
        pointOfNeedChat(LaunchPointName.Disputes, accountId);
        dispatch(closeModalHelper(DisputeFeature.DisputeCenter));
    };
    useEffect(function () {
        triggerAnalyticsEvent({
            PageKind: Analytics.Dispute,
            PageFunction: Analytics.Billing,
            PageSubFunction: Analytics.DuplicateTransaction,
            pageName: Analytics.NotFound
        });
    }, []);
    return (_jsxs(Content, { children: [_jsx(ContactFraudImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "MORE_INFO", size: imageSize }) }), _jsx(Header, { children: t('cantIdentify.title') }), _jsx(Description, { children: _jsx(Trans, { i18n: i18n, i18nKey: "cantIdentify.description", components: [
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": Analytics.OnlineChat, "data-title": "transaction-enrichment", "data-type": Analytics.DisputeTransaction, onClick: handleLaunchChat }, "online chat")
                    ] }) })] }));
};
export default CantIdentifyDup;
var templateObject_1;
//# sourceMappingURL=index.js.map